import React from 'react';
import instagramIcon from "../assets/images/icons8-instagram.svg";

const InstagramCTA = () => {
  return (
    <div className="flex justify-center relative mt-4">
        <div className="flex items-center justify-center">
        <img loading="lazy" src={instagramIcon} className="w-1/6" alt="instagram icon" />
        <span className="text-4xl font-serif">POLLAROW.ID</span>
        </div>
      </div>
  )
}

export default InstagramCTA
